import { Text } from "@mantine/core";
import { ServiceCenterComponentProps } from "./types";

export function ServiceCenterComponent(props: ServiceCenterComponentProps) {
  const { value } = props;

  return <Text style={{ maxWidth: 150 }}>{value}</Text>;
}
